import { Box } from "@mui/system";
import { ExerciseInterface, PDFExamContainerInterface } from "../../../../interfaces/examInterfaces";
import {
  ExamSheetContainerPdf,
  TopSpacer,
  TitleBox,
  ExamTitle,
  HandWritingBox,
  HandWriting,
  LineNameStudent,
  ObjectiveBox,
  ObjectiveTitle,
  Objective,
  ExercisesContainer,
  TotalPointsContainer,
  TotalPoints,
  TypographyCopyrightPdf,
  Copyright,
} from "./PizLinardStyles";
import LegacyPDFExercise from "./PizLinardPDFExercise";

export const PizLinardPDFContainer = ({
  pageIndex,
  selectedObjective,
  pages,
  pageExercises,
  examName,
  totalPoints,
  imageUrls,
  solutionImageUrls,
  pageNumber,
  createPageNumbers,
  zoomFactor,
}: PDFExamContainerInterface) => {
  return (
    <ExamSheetContainerPdf zoomfactor={zoomFactor}>
      <TopSpacer zoomfactor={zoomFactor} />
      {pageIndex === 0 && (
        <>
          <TitleBox zoomfactor={zoomFactor}>
            <ExamTitle zoomfactor={zoomFactor}>{selectedObjective.topic}</ExamTitle>
            <HandWritingBox zoomfactor={zoomFactor}>
              <HandWriting zoomfactor={zoomFactor}>Name:</HandWriting>
              <LineNameStudent />
            </HandWritingBox>
          </TitleBox>
          <ObjectiveBox zoomfactor={zoomFactor}>
            <ObjectiveTitle zoomfactor={zoomFactor}>Kompetenz {selectedObjective.objectiveIndex}</ObjectiveTitle>
            <Objective zoomfactor={zoomFactor}>{selectedObjective.objective}</Objective>
          </ObjectiveBox>
        </>
      )}

      <ExercisesContainer>
        {pageExercises.map((exercise: ExerciseInterface, index: number) => {
          const imageUrl = imageUrls[exercise.id];
          const solutionImageUrl = solutionImageUrls[exercise.id];
          if (!imageUrl || !solutionImageUrl) {
            return null;
          }

          return (
            <div key={exercise.id}>
              <LegacyPDFExercise
                exercise={exercise}
                imageUrl={imageUrl}
                solutionImageUrl={solutionImageUrl}
                zoomFactor={zoomFactor}
              />
            </div>
          );
        })}
      </ExercisesContainer>

      {pageIndex === pages.length - 1 && (
        <TotalPointsContainer zoomfactor={zoomFactor}>
          <TotalPoints zoomfactor={zoomFactor}>/ {totalPoints}</TotalPoints>
        </TotalPointsContainer>
      )}

      <Copyright zoomfactor={zoomFactor}>
        <TypographyCopyrightPdf zoomfactor={zoomFactor}>{examName}</TypographyCopyrightPdf>
        <TypographyCopyrightPdf zoomfactor={zoomFactor}>
          <Box>
            © didacto - {selectedObjective.topic} - Kompetenz {selectedObjective.objectiveIndex}
          </Box>
          {createPageNumbers && <Box>Seite {pageNumber}</Box>}
        </TypographyCopyrightPdf>
      </Copyright>
    </ExamSheetContainerPdf>
  );
};
